export default __webpack_public_path__ + "static/media/findingVenus.99adac02.wav";